<template>
	<div class="pageContainer targetPage flexCloumn">
		<el-row class="searchBar flexBetween" style="flex-wrap: wrap;width:100%">
			<div class="flexStart flex_1" style="flex-wrap:wrap;">
				<span>搜索关键字：</span>
				<el-input v-model="searchForm.keyword" size="small" placeholder="请输入" clearable style="max-width: 200px;" />
        <el-select v-model="searchForm.project_id" size="small" placeholder="选择体育项目" @change="getList" style="margin-left: 10px;">
          <el-option v-for="(item,index) in sportProjects"
                     :label="item.project_name"
                     :value="item.id" :key="index"></el-option>
        </el-select>
				<el-button size="small" icon="el-icon-search" type="primary" style="margin-left: 10px;" @click="getList">查询</el-button>

				<div style="float:right">
					<el-button size="small" icon="el-icon-plus" type="primary" plain
                     style="margin-left: 10px;" @click="handleAdd">新增
					</el-button>
				</div>
			</div>
		</el-row>
		<div class="dividerBar"></div>
    <el-table v-tableFit :data="tableData" height="100%" size="small" stripe border @cell-dblclick="dbEdit" style="width:fit-content;width:100%;">
      <el-table-column prop="session_name"   label="节次" min-width="120" align="center"></el-table-column>
      <el-table-column v-for="(week,idx) in weeks" :label="week" :key="idx" min-width="120"  align="center">
        <template slot-scope="scope">
          <div style="font-weight: bold">{{ scope.row.weeks[idx].lesson_name }}</div>
          <div v-if="scope.row.weeks[idx].teacher_name" style="font-size: 13px;">{{ `(${scope.row.weeks[idx].teacher_name})` }}</div>
        </template>
      </el-table-column>
    </el-table>

		<el-dialog title="添加/修改" :visible.sync="isShowModal" :close-on-click-modal="false" :destroy-on-close="true"
			custom-class="cus_dialog">
			<el-form :model="formData" ref="ruleform" label-width="120px"
				style="max-height: 500px;overflow-y: auto;min-height: 300px;">
        <el-form-item label="体育项目" prop="project_id" :rules="[{required:true,message:'请选择体育项目',trigger:'change'}]">
          <el-select v-model="formData.project_id" placeholder="请选择体育项目" style="width:50%" @change="changeProject">
            <el-option v-for="(item,index) in sportProjects" :label="item.project_name" :value="item.id" :key="index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="周次" prop="week" style="width:50%" :rules="[{required:true,message:'请选择周次',trigger:'change'}]">
          <el-select v-model="formData.week">
            <el-option v-for="(w,idx) in weeks" :label="w" :value="idx+1" :key="idx"></el-option>
          </el-select>
        </el-form-item>
				<el-form-item label="节次" prop="session" style="width:50%" :rules="[{required:true,message:'请选择节次',trigger:'change'}]">
					<el-select v-model="formData.session">
            <el-option v-for="(s,idx) in sessions" :label="s" :value="idx+1" :key="idx"></el-option>
          </el-select>
				</el-form-item>
        <el-form-item label="选择课程" prop="lesson_id" :rules="[{required:true,message:'请选择课程',trigger:'change'}]">
          <el-select v-model="formData.lesson_id" placeholder="请选择课程" style="width:50%">
            <el-option v-for="(item,index) in lessons" :label="item.lesson_name" :value="item.id" :key="index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="选择教师" prop="teacher_id" :rules="[{required:true,message:'请选择教师',trigger:'change'}]">
          <el-select v-model="formData.teacher_id" placeholder="请选择教师" style="width:50%">
            <el-option v-for="(item,index) in teachers" :label="item.username" :value="item.id" :key="index"></el-option>
          </el-select>
        </el-form-item>
			</el-form>
			<template slot="footer">
        <el-button size="small" type="default" @click="isShowModal = false">取消</el-button>
        <el-button size="small" type="primary" @click="submitForm">保存</el-button>
        <el-popconfirm v-if="formData.id && showDelBtn" confirmButtonText='确定' cancelButtonText='取消' icon="el-icon-info"
                       iconColor="red" @confirm="handleDel(formData.id)" placement="left" title="是否确定删除？">
          <el-button size="small" type="danger" slot="reference" style="margin-left: 10px;">删除当前课程</el-button>
        </el-popconfirm>
      </template>
		</el-dialog>
	</div>
</template>
<script>
import tchtree from '../com/tchTree.vue'
import moment from "moment";
export default {
	name: 'dept',
	components: {tchtree},
	data() {
		return {
			visible: false,
			isShowModal: false,
			isShowModalAuth: false,
			importTeacherShow: false,
			modalTitle: '添加',
			DeptUserDialog: false,
			showDeptroleManage: false,
			activeRoleID: "",
			formData: {
        lesson_id: ""
      },
			fgxz: [],
			activeName: 'CN',
			tableData: [],

			teacherList: [],
			editUser: {},
			deptId: null,
			editDeptRole: {},
			deptRoleList: [],
			isShowDeptRole: false,
			biye: 0,

			page: {
				count: 0,
				current_page: 1,
				per_page: 50,
				total_page: 0
			},
			searchForm: {

				ktype: "username",
				keyword: "",
				project_id: ""
			},
			multipleSelection: [],
			treeData: [],
			ckdTreeData: [],
			firstCascaderProps: {
				label: "name",
				children: "children",
			},
			defaultProps: {
				label: 'name',
				value: 'id',
				children: 'children',
				emitPath: false,
				checkStrictly: true
			},
			DataAuth: [],
			showTeacherInfo: false,
			teacher_id: 0,
			schoolYears: [],
      failedImportData: [],
      sportProjects: [],
      lessons: [],
      teachers: [],
      weeks: ['星期一','星期二','星期三','星期四','星期五','星期六','星期日'],
      sessions: ['第一节','第二节','第三节','第四节','第五节','第六节','第七节','第八节'],
      showDelBtn: false,
		}
	},

	mounted() {
    this.getTeachers()
    this.getSportsProject().then(() => {
      this.getList()
    })
	},
	methods: {
    getTeachers() {
      this.$http.post('/api/t_sch_teachers_list',{page:1,pagesize:1000}).then(res => {
        this.teachers = res.data.data
      })
    },
    getSportsProject() {
     return new Promise((resolve, reject) => {
       this.$http.post('/api/sport_project_list',{page:1,pagesize:100}).then(res => {
         this.sportProjects = res.data.data
         this.searchForm.project_id = res.data.data[0].id
         resolve("")
       })
     })
    },
    getList() {
      this.$http.post('/api/lesson_time_list',{
        page: this.page.current_page,
        pagesize: this.page.per_page ? this.page.per_page : 20,
        keyword: this.searchForm.keyword,
        project_id: this.searchForm.project_id,
      }).then(res => {
        this.tableData = res.data
      })
    },
    handleAdd() {
      this.isShowModal = true;
      this.showDelBtn = false;
      this.formData = {
        lesson_id: ''
      }
      this.lessons = []
      this.$nextTick(() => {
        this.$refs.ruleform.clearValidate()
      })
    },
		handleModify(row) {
			this.isShowModal = true;
			let formData = JSON.parse(JSON.stringify(row))
      formData.dateRange = [formData.start_date,formData.end_date]
			this.formData = formData
      this.changeProject(formData.project_id, true)
		},
		handleDel(id) {
			this.$http.post("/api/lesson_time_delete", {
				id: String(id)
			}).then(res => {
				this.$message.success('删除成功')
        this.isShowModal = false
				this.getList();
			})
		},

		submitForm() {
			let params = {
				...this.formData
			}
			this.$refs.ruleform.validate(valid => {
        if (valid) {
          this.$http.post("/api/lesson_time_edit", params).then(res => {
            this.$message.success('保存成功')
            this.getList()
            this.isShowModal = false;
          })
        }
      });
		},
    handlePageChange(e) {
      this.page.current_page = e
      this.getList()
    },
    handleSizeChange(e) {
      this.page.per_page = e
      this.getList()
    },
    changeProject(val,isEdit = false) {
      if (!isEdit) {
        this.formData.lesson_id = ""
        this.$nextTick(() => {
          this.$refs.ruleform.clearValidate()
        })
      }
      this.$http.post('/api/lesson_list',{project_id:val,lesson_type:1,pagesize:100}).then(res => {
        this.lessons = res.data.data
      })
    },
    dbEdit(row,column) {
      if (column.label != '节次') {
        this.isShowModal = true
        this.showDelBtn = true
        this.formData.project_id = this.searchForm.project_id
        this.formData.week = this.weeks.indexOf(column.label) + 1
        this.formData.session = this.sessions.indexOf(row.session_name) + 1
        this.changeProject(this.searchForm.project_id)
        this.formData.lesson_id = row.weeks[this.formData.week - 1].lesson_id
        this.formData.teacher_id = row.weeks[this.formData.week - 1].teacher_id
        this.formData.id = row.weeks[this.formData.week - 1].id
      }
    },
	}
}
</script>
<style scoped lang="less" type="text/less">
.app-container {

	.treeContainer {
		height: 100%;
		background-color: #fff;
		box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.12), 0 0 6px 0 rgba(0, 0, 0, 0.04);
		border: 1px solid rgba(220, 223, 230, 0.6);
		margin-right: 20px;
		padding-right: 10px;

		.treeTitle {
			height: 40px;
			display: flex;
			justify-content: flex-start;
			align-items: center;
			color: #409eff;
			padding-left: 6px;
		}
	}
}

.nodetag {
	display: inline-block;
	padding: 0 5px;
	font-size: 12px;
	transform: scale(0.8, 0.8);
	background-color: #409eff;
	color: #fff;
	border-radius: 4px;
}
</style>
